// import { useState, useEffect } from "react";
// import api from "../../../core/axios/axiosInstance";

// const AdminPushNotifications = () => {
//   const [title, setTitle] = useState("");
//   const [message, setMessage] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [history, setHistory] = useState([]);

//   const handleSend = async () => {
//     if (!title || !message) {
//       alert("Please fill out both title and message");
//       return;
//     }

//     setLoading(true);
//     try {
//       const payload = {
//         heading:title,
//         message,
//       };

//     const response =  await api.post("/admin/notification", payload);
// console.log(response.data,"response from send push notification");

//       alert("✅ Notification sent to all users successfully!");
//       setTitle("");
//       setMessage("");

//     } catch (error) {
//       console.error("❌ Send failed:", error);
//       alert("Failed to send notification");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     const fetchNotifications = async () => {
//       try {
//         const res = await api.get("/admin/notification/get");
//         setHistory(
//           Array.isArray(res.data)
//             ? res.data
//             : res.data?.notifications || res.data?.data || []
//         );
//       } catch (error) {
//         console.error("❌ Failed to fetch notifications:", error);
//       }
//     };

//     fetchNotifications();
//   }, []);

//   return (
//     <div className="page-wrapper">
//       <div className="content">
//         <div className="card">
//           <div className="card-body">
//             <h5 className="card-title">Create Notification</h5>

//             <div className="mb-3">
//               <label className="form-label">Title</label>
//               <input
//                 type="text"
//                 className="form-control"
//                 value={title}
//                 onChange={(e) => setTitle(e.target.value)}
//                 placeholder="Enter notification title"
//               />
//             </div>

//             <div className="mb-3">
//               <label className="form-label">Message</label>
//               <textarea
//                 className="form-control"
//                 rows="3"
//                 value={message}
//                 onChange={(e) => setMessage(e.target.value)}
//                 placeholder="Enter notification message"
//               />
//             </div>

//             <button
//               className="btn btn-success"
//               onClick={handleSend}
//               disabled={loading}
//             >
//               {loading ? "Sending..." : "Send to All Users"}
//             </button>
//           </div>
//         </div>

//         {/* Notification History */}
//         <div className="card mt-4">
//           <div className="card-body">
//             <h5 className="card-title">Notification History</h5>
//             <table className="table">
//               <thead>
//                 <tr>
//                   <th>Title</th>
//                   <th>Message</th>
//                   <th>Number of Recipients</th>
//                   <th>Sent On</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {Array.isArray(history) && history.length > 0 ? (
//                   history.map((item) => (
//                     <tr key={item.id}>
//                       <td>{item.heading}</td>
//                       <td>{item.message}</td>
//                       <td>
//                         {Array.isArray(item.sentToUsers)
//                           ? item.sentToUsers.length
//                           : 0}
//                       </td>
//                       <td>
//                         {item.createdAt
//                           ? new Date(item.createdAt).toLocaleString()
//                           : "-"}
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="4" className="text-center text-muted">
//                       No notifications yet
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdminPushNotifications;

import { useState, useEffect } from "react";
import api from "../../../core/axios/axiosInstance";

const AdminPushNotifications = () => {
  const [heading, setHeading] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [history, setHistory] = useState([]);

  // ✅ Fetch notifications
  const fetchNotifications = async () => {
    try {
      const res = await api.get("/admin/notification/get");
      setHistory(
        Array.isArray(res.data)
          ? res.data
          : res.data?.notifications || res.data?.data || []
      );
    } catch (error) {
      console.error("❌ Failed to fetch notifications:", error);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  // ✅ Send notification
  const handleSend = async () => {
    if (!heading || !message) {
      alert("Please fill out both heading and message");
      return;
    }

    setLoading(true);
    try {
      const payload = {
        heading,
        message,
      };

      const response = await api.post("/admin/notification", payload);
      console.log(response.data, "response from send push notification");

      alert("✅ Notification sent to all users successfully!");
      setHeading("");
      setMessage("");

      // ✅ Refresh notification history after sending
      await fetchNotifications();
    } catch (error) {
      console.error("❌ Send failed:", error);
      alert("Failed to send notification");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="card">
          <div className="card-body">
            <h5 className="card-title">Create Notification</h5>

            <div className="mb-3">
              <label className="form-label">Heading</label>
              <input
                type="text"
                className="form-control"
                value={heading}
                onChange={(e) => setHeading(e.target.value)}
                placeholder="Enter notification heading"
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Message</label>
              <textarea
                className="form-control"
                rows="3"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Enter notification message"
              />
            </div>

            <button
              className="btn btn-success"
              onClick={handleSend}
              disabled={loading}
            >
              {loading ? "Sending..." : "Send to All Users"}
            </button>
          </div>
        </div>

        {/* Notification History */}
        <div className="card mt-4">
          <div className="card-body">
            <h5 className="card-title">Notification History</h5>
            <table className="table">
              <thead>
                <tr>
                  <th>Heading</th>
                  <th>Message</th>
                  <th>Number of Recipients</th>
                  <th>Sent On</th>
                </tr>
              </thead>
              {/* <tbody>
                {Array.isArray(history) && history.length > 0 ? (
                  history.map((item) => (
                    <tr key={item.id}>
                      <td>{item.heading}</td>
                      <td>{item.message}</td>
                      <td>
                        {Array.isArray(item.sentToUsers)
                          ? item.sentToUsers.length
                          : 0}
                      </td>
                      <td>
                        {item.createdAt
                          ? new Date(item.createdAt).toLocaleString()
                          : "-"}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center text-muted">
                      No notifications yet
                    </td>
                  </tr>
                )}
              </tbody> */}
              <tbody>
                {Array.isArray(history) && history.length > 0 ? (
                  history.map((item) => (
                    <tr key={item.id}>
                      <td
                        style={{
                          maxWidth: "200px",      // limit cell width
                          maxHeight: "50px",      // limit cell height
                          overflowY: "auto",      // vertical scroll if needed
                          overflowX: "auto",
                          wordBreak: "break-word", // break long words
                        }}
                      >
                        {item.heading}
                      </td>

                      <td
                        style={{
                          maxWidth: "300px",      // limit cell width
                          maxHeight: "80px",      // limit cell height
                          overflowY: "auto",      // vertical scroll
                          overflowX: "auto",
                          wordBreak: "break-word", // break long words
                        }}
                      >
                        {item.message}
                      </td>

                      <td>
                        {Array.isArray(item.sentToUsers) ? item.sentToUsers.length : 0}
                      </td>
                      <td>
                        {item.createdAt ? new Date(item.createdAt).toLocaleString() : "-"}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center text-muted">
                      No notifications yet
                    </td>
                  </tr>
                )}
              </tbody>


            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminPushNotifications;
